@if (updateValueCSL()) {}
<div class="container">
  <p>{{ label() }}</p>
  <form class="time-range" [formGroup]="timeSpanForm">
    <div class="time-input">
      <vectronic-formly-time-input-box
        [control]="getFormControl('fromHours')"
        [maxValue]="fromHoursMaxCSL()"
        [numberOfDigits]="2"
      ></vectronic-formly-time-input-box>
      <span class="time-input__delimeter">:</span>
      <vectronic-formly-time-input-box
        [control]="getFormControl('fromMinutes')"
        [maxValue]="fromMinutesMaxCSL()"
        [numberOfDigits]="2"
      ></vectronic-formly-time-input-box>
    </div>
    <span class="time-range__delimeter">-</span>
    <div class="time-input">
      <vectronic-formly-time-input-box
        [control]="getFormControl('toHours')"
        [minValue]="toHoursMinCSL()"
        [maxValue]="toHoursMaxCSL()"
        [numberOfDigits]="2"
      ></vectronic-formly-time-input-box>
      <span class="time-input__delimeter">:</span>
      <vectronic-formly-time-input-box
        [control]="getFormControl('toMinutes')"
        [minValue]="toMinutesMinCSL()"
        [maxValue]="toMinutesMaxCSL()"
        [numberOfDigits]="2"
      ></vectronic-formly-time-input-box>
    </div>
  </form>
</div>
